<section id="landing-screen" class="section">
  <div class="section--container">
    <div class="row">
      <div class="col-lg-6">
        <h1 class="d-sm-block text-primary text-ultra m-b-2">
          Advanced Protection <br />
          For Your Ads Margins.
        </h1>
        <p class="fs-1-25">
          Protecting over <strong>1B impressions</strong> per day<br />for leading advertisers and ad networks.
        </p>
      </div>
    </div>
  </div>
</section>

<div id="homepage-content">
  <app-content-divider></app-content-divider>

  <section class="section">
    <div class="section--container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <p class="fs-1 lh-1-7">
            <span class="text-brand"><span>AD</span>SCORE</span>’s mission is to categorize web traffic that is
            organically generated or purchased by your business. It detects the following categories of traffic: human,
            proxy, low quality (obsolete device and/or browser) and of course, bots.
          </p>

          <p class="fs-1 lh-1-7 m-t-1-25">
            Detection is done by a highly scalable, continuously improving system. The detection model is updated on a
            daily basis, using quality training data that contains all categories of traffic. Adscore can be used by
            Advertisers, Ad Networks and Publishers alike, to check the quality of the traffic that is bought or sold.
          </p>

          <p class="fs-1 lh-1-7 m-t-1-25 text-bold">
            We aim to offer high quality detection at a very competitive price point.
          </p>
        </div>
      </div>
    </div>
  </section>

  <app-content-divider></app-content-divider>

  <section class="section">
    <div class="section--container">
      <div class="row justify-content-center">
        <div class="col-md-4 text-left">
          <div class="feature">
            <div
              id="feature-illustration-01"
              class="feature-illustration"
              role="img"
              aria-label="bot traffic detection"
              [inlineSVG]="'/assets/img/adscore--feature--bot-traffic-detection.min.svg'"
            ></div>
            <h2 class="text-primary text-ultra fs-1-25 lh-1-1 m-t-1 m-b-1">Bot Traffic Detection</h2>
            <p class="fs-0-9 lh-1-5">
              Bots make up a consistent chunk of internet traffic. They mean ad fraud, drained advertising budgets and
              wasted computing power. Your hard-worked ad campaigns might even be stolen by bots of Ad Spy tools.
              <span class="d-block text-bold m-t-0-5"
                >Come under <span class="text-brand"><span>AD</span>SCORE</span>'s wing.</span
              >
            </p>
          </div>
        </div>
        <div class="col-md-4 text-left">
          <div class="feature">
            <div
              id="feature-illustration-02"
              class="feature-illustration"
              role="img"
              aria-label="scraping protection"
              [inlineSVG]="'/assets/img/adscore--feature--scraping-protection.min.svg'"
            ></div>
            <h2 class="text-primary text-ultra fs-1-25 lh-1-1 m-t-1 m-b-1">Scraping Protection</h2>
            <p class="fs-0-9 lh-1-5">
              You were assuming that having your web content scraped and re-published is a necessary evil. And you can
              only protect yourself with captchas by compromising your human visitors’ experience.
              <span class="d-block text-bold m-t-0-5"
                >Come under <span class="text-brand"><span>AD</span>SCORE</span>'s wing.</span
              >
            </p>
          </div>
        </div>
        <div class="col-md-4 text-left">
          <div class="feature">
            <div
              id="feature-illustration-03"
              class="feature-illustration"
              role="img"
              aria-label="low quality human traffic detection"
              [inlineSVG]="'/assets/img/adscore--feature--low-quality-human-traffic.min.svg'"
            ></div>
            <h2 class="text-primary text-ultra fs-1-25 lh-1-1 m-t-1 m-b-1">Low Quality Human Traffic Detection</h2>
            <p class="fs-0-9 lh-1-5">
              Correctly targeting users according to their buying power and conversion rates is essential to running
              profitable campaigns. You can now accurately detect users with out of date operating systems and devices.
              <span class="d-block text-bold m-t-0-5"
                >Come under <span class="text-brand"><span>AD</span>SCORE</span>'s wing.</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-content-divider></app-content-divider>
  <app-cta
    [ctaText]="'Stop buying fraudulent traffic.'"
    [ctaPosition]="'home-footer'"
    [buttonText]="'Get Started'"
  ></app-cta>
</div>

<ng-container *ngIf="displayLoader">
  <div id="loading-indicator">
    <div class="center">
      <div class="logo"></div>
      <div id="balls">
        <div class="ball-pulse o-0-5 d-inline-block">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-password-reset *ngIf="showPasswordReset"></app-password-reset>
